import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          'As of': 'As of',
          'CRS Attribution': 'Composite Risk Score Attribution',
          'Shareholder Yield Attribution': 'Shareholder Yield Attribution',
          'Size Attribution': 'Size Attribution',
          'Return on Equity Attribution': 'Return on Equity Attribution',
          'Earnings Yield Attribution': 'Earnings Yield Attribution',
          'Dividend Yield Attribution': 'Dividend Yield Attribution',
          'Sector Attribution': 'Sector Attribution',
          'Country Attribution': 'Country Attribution',
          'Volatility Attribution': 'Volatility Attribution',
          'Book Value Attribution': 'Book Value Attribution',
          'State-Ownership Attribution': 'State-Ownership Attribution',
          'Geographic Revenue Attribution': 'Geographic Revenue Attribution',
          'Share Class Attribution': 'Share Class Attribution',
          'SY-gloss': 'Shareholder Yield: A data point that references the combination of dividend yield and buyback yield.',
          'BB-gloss': 'Net Buyback Yield: A company’s net share buyback is the difference between the capital raised by issuing new shares and the money the company spent on buying back any outstanding shares. A positive net share buyback means that more was spent on buying back existing shares than received from issuing new shares. Net buyback yield is the amount of a company’s net buybacks divided by its market capitalization. Please note that net buyback yield does not represent a dividend paid by the company.',
          'ROE-gloss': 'Return on Equity (ROE): Measures a corporation’s profitability by revealing how much profit a company generates with the money shareholders have invested.',
          'EY-gloss': 'Earnings Yield: The earnings per share for the most recent 12-month period divided by the current market price per share. The earnings yield (which is the inverse of the P/E ratio) shows the percentage of each dollar invested in the stock that was earned by the company.',
          'DY-gloss': 'Dividend Yield: A financial ratio that shows how much a company pays out in dividends each year relative to its share price.',
          'Since Inception': 'Since Inception',
          '1Y': '1Y',
          '3Y': '3Y',
          '5Y': '5Y',
          '10Y': '10Y',
          'MTD': 'MTD',
          'QTD': 'QTD',
          'YTD': 'YTD',
          'Select a WisdomTree Index': 'Select a WisdomTree Index',
          'Select a Benchmark': 'Select a Benchmark',
          'EXPORT EXCEL': 'EXPORT EXCEL',
          'Fetching Excel': 'fetching excel',
          'Attribution Component': 'Attribution Component',
          'Average Category Weight': 'Average Category Weight',
          'Category Performance': 'Category Performance',
          'Category': 'Category',
          'Allocation': 'Allocation',
          'Selection': 'Selection',
          'Interaction': 'Interaction',
          'Attribution': 'Attribution',
          'Index': 'Index',
          'Weight': 'Weight',
          'Benchmark': 'Benchmark',
          'Wgt': 'Wgt',
          'Return': 'Return',
          'comp-source': 'Source: WisdomTree, FactSet. Index Inception Date',
          'comp-view': 'View Index Details Page',
          'comp-inception': '*Since inception returns are calculated from the last trading day of the month.',
          'comp-average': 'Average weights refer to the average weight over the analysis period. Allocation refers to the portion of return which is attributable to a category\'s over weight vs. the benchmark. Stock selection refers to the portion of return which is attributable to the equities held vs the benchmark. Interaction refers to the portion of return attributable to the effects of how the selection and allocation effects interact with each other within the portfolio versus the same effects in the benchmark. Weights subject to change.',
          'comp-past': 'Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment  may be worth more or less than their original cost. ',
          'comp-shares': 'WisdomTree shares are bought and sold at market price (not NAV) and are not individually redeemed from the Fund. Total Returns are calculated using the daily 4:00 p.m. EST net asset value (NAV). Market price returns reflect the midpoint of the bid/ask spread as of the close of trading on the exchange where Fund shares are listed. Market price returns do not represent the returns you would receive if you traded shares at other times.',
          'comp-gics': 'The Global Industry Classification Standard (“GICS”) was developed by and is the exclusive property and a service mark of MSCI Inc. (“MSCI”) and Standard & Poor’s (“S&P”), a division of The McGraw-Hill Companies, Inc., and is licensed for use by WisdomTree Investments, Inc. Neither MSCI, S&P nor any other party involved in making or compiling the GICS or any GICS classifications makes any express or implied warranties or representations with respect to such standard or classification (or the results to be obtained by the use thereof), and all such parties hereby expressly disclaim all warranties of originality, accuracy, completeness, merchantability and fitness for a particular purpose with respect to any such standard or classification. Without limiting any of the foregoing, in no event shall MSCI, S&P, any of their affiliates or any third party involved in making or compiling the GICS or any GICS classifications have any liability for any direct, indirect, special, punitive, consequential or any other damages (including lost profits), even if notified of the possibility of such damages.',
          'Performance Attribution': 'Performance Attribution',
          'Total Attribution': 'Total Attribution',
          'Average Weights': 'Average Weights',
          'Over/Under Weight': 'Over/Under Weight',
          'Energy': 'Energy',
          'Industrials': 'Industrials',
          'Materials': 'Materials',
          'Utilities': 'Utilities',
          'Health Care': 'Health Care',
          'Consumer Staples': 'Consumer Staples',
          'Other': 'Other',
          'Real Estate': 'Real Estate',
          'Financials': 'Financials',
          'Communication Services': 'Communication Services',
          'Consumer Discretionary': 'Consumer Discretionary',
          'Information Technology': 'Information Technology',
          'Total': 'Total',
          '1st Quintile (Highest Div. Yield)': '1st Quintile (Highest Div. Yield)',
          '2nd Quintile': '2nd Quintile',
          '3rd Quintile': '3rd Quintile',
          '4th Quintile': '4th Quintile',
          '5th Quintile (Lowest Div. Yield)': '5th Quintile (Lowest Div. Yield)',
          'Zero Div. Yield': 'Zero Div. Yield',
          'N/A': 'N/A',
          '1st Quintile (Lowest P/E)': '1st Quintile (Lowest P/E)',
          '5th Quintile (Highest P/E)': '5th Quintile (Highest P/E)',
          '1st Quintile (Highest ROE)': '1st Quintile (Highest ROE)',
          '5th Quintile (Lowest ROE)': '5th Quintile (Lowest ROE)',
          'Negative Return': 'Negative Return',
          'Negative Earners': 'Negative Earners',
          '1st Quintile (Highest Shld. Yield)': '1st Quintile (Highest Shld. Yield)',
          '5th Quintile (Lowest Shld. Yield)': '5th Quintile (Lowest Shld. Yield)',
          'Zero & Neg. Yield': 'Zero & Neg. Yield',
          'Large': 'Large',
          'Mid': 'Mid',
          'Small': 'Small',
          '1st Quintile (Lowest Volatility)': '1st Quintile (Lowest Volatility)',
          '5th Quintile (Highest Volatility)': '5th Quintile (Highest Volatility)',
          '1st Quintile (Lowest P/B)': '1st Quintile (Lowest P/B)',
          '5th Quintile (Highest P/B)': '5th Quintile (Highest P/B)',
          'Negative Book Value': 'Negative Book Value',
          'Composite Risk Score': 'Composite Risk Score is calculated by an equally weighted score of the Quality and Momentum Factors.  Quality Factor is determined by static observations and trends of return on equity (ROE), return on assets (ROA), gross profits over assets and cash flows over assets. Scores are calculated within industry groups.  Momentum Factor is determined by stock’s risk adjusted total returns over historical periods (6 and 12 month).  Composite Risk Scores were developed to mitigate the impact of “value traps” by identifying companies deemed most at risk of cutting or cancelling their dividend payments. Companies with lower composite risk score stand greater risk of cutting their dividend payments and can be excluded from WisdomTree indexes according to their respective methodology. Please see Glossary for definition of terms.',
          'comp-std': 'Standardized and the most recent month-end  performance can be found on the details tab.',
          'comp-prospectus': ' A prospectus for each fund can be found on the fund details tab.'
        },
      },
    },
  });

export default i18n;









// WEBPACK FOOTER //
// ./src/i18n.js